import { Modal } from "antd";
import CalendarTaskInput from "./CalendarTaskInput";
import CalendarTimeInput from "./CalendarTimeInput";
import ModalFooter from "./ModalFooter";
import { EditSessionModalContext } from "./types";
import { useEditSessionModal } from "./useEditSessionModal";
const EditSessionModal = ({
  session,
  onUpdate,
  isModalVisible,
  onClose,
}: {
  session: any;
  onUpdate: () => void;
  isModalVisible: boolean;
  onClose: () => void;
}) => {
  const handleCancel = () => {
    onClose();
  };
  const hook = useEditSessionModal(session, onUpdate);
  return (
    <Modal
      visible={isModalVisible}
      onCancel={handleCancel}
      footer={null}
      width={480}
      bodyStyle={{ padding: "36px 28px 20px" }}
    >
      <EditSessionModalContext.Provider value={hook}>
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <CalendarTaskInput />
          <CalendarTimeInput />
          <ModalFooter sessionId={session.id} onClose={onClose} />
        </div>
      </EditSessionModalContext.Provider>
    </Modal>
  );
};

export default EditSessionModal;
